import Image from 'next/image';

import { imgPrefix } from '../../../utils/imgPrefix';
import styles from './HeaderPF.module.scss';

const PRECO_FECHADO_URL = 'https://www.getninjas.com.br/precofechado';

function PF() {
  return (
    <header className={styles['header-pf']}>
      <div className={styles['header-pf__container']}>
        <a
          href={process.env.NEXT_PUBLIC_HOST || '/'}
          className={styles['header-pf__logo']}
        >
          <Image
            src={imgPrefix('/images/shared/logo-getninjas-text.svg')}
            alt="GetNinjas"
            width={71}
            height={16}
          />
        </a>

        <nav className={styles['header-pf__nav']}>
          <a
            className={`${styles['header-pf__tab']} ${styles['header-pf__tab--active']}`}
            href={process.env.NEXT_PUBLIC_HOST || '/'}
          >
            Orçamentos com profissionais
          </a>
          <a
            className={styles['header-pf__tab']}
            href={PRECO_FECHADO_URL}
            aria-label="Serviços com preço fechado"
          >
            <span className={styles['header-pf__tab-text--full']}>
              Serviços com preço fechado
            </span>
            <span className={styles['header-pf__tab-text--short']}>
              Preço Fechado
            </span>
          </a>
        </nav>
      </div>
    </header>
  );
}

export { PF };
